import React, { useEffect, useRef, useState } from "react";
import "./Product_description.css";

import { useParams } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import Enquire_from_modal from "../common-components/common_modal/enquire_from_modal/Enquire_from_modal";
import Heading_title from "../common-components/common-title/heading-title/Heading_title";
import Inner_Products from "../products/inner_products/Inner_Products";

import { getProductById } from "../../utils/apis/products/Product";
import { IDS } from "../../utils/common";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileArrowDown,
  faBookOpen,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Product_Description = () => {
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [activeImage, setActiveImage] = useState(0);

  // Main Swiper reference
  const mainSwiperRef = useRef(null);

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const fetchProduct = async () => {
    try {
      setLoading(true);

      const res = await getProductById(id);

      if (res?.success) {
        setProduct(res.data);
        setActiveImage(0);
      } else {
        setProduct(null);
      }
    } catch (error) {
      console.log("Error fetching product:", error);
      setProduct(null);
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // LOADING
  // =====================================================

  if (loading) {
    return (
      <div className="text-center py-5">
        <h3>Loading...</h3>
      </div>
    );
  }

  // =====================================================
  // PRODUCT NOT FOUND
  // =====================================================

  if (!product) {
    return (
      <div className="text-center py-5">
        <h3>Product Not Found</h3>
      </div>
    );
  }

  // =====================================================
  // PRODUCT IMAGES
  // =====================================================

  const productImages = [
    ...(product?.image ? [{ image: product.image }] : []),
    ...(product?.product_images || []),
  ];

  // =====================================================
  // IMAGE URL
  // =====================================================

  const getImageUrl = (image) => {
    if (!image) return "";

    return IDS?.IMG_URL + image;
  };

  // =====================================================
  // THUMBNAIL CLICK
  // =====================================================

  const handleThumbnailClick = (index) => {
    setActiveImage(index);

    // Move main Swiper to clicked thumbnail
    if (mainSwiperRef.current) {
      mainSwiperRef.current.slideTo(index);
    }
  };

  // =====================================================
  // MAIN SWIPER CHANGE
  // =====================================================

  const handleMainSlideChange = (swiper) => {
    setActiveImage(swiper.activeIndex);
  };

  return (
    <>
      {/* =====================================================
          PRODUCT DESCRIPTION SECTION
      ===================================================== */}

      <section className="product_description_section">
        <Heading_title title="Product Description" />

        <div className="container">
          <div className="product_description_card">
            <div className="row align-items-stretch g-0">

              {/* =====================================================
                  PRODUCT IMAGE SECTION
              ===================================================== */}

              <div className="col-lg-5 col-md-5 col-12 product_image_col">
                <div className="product_image_box">

                  {/* =====================================================
                      MAIN IMAGE SWIPER
                  ===================================================== */}

                  <div className="product_main_image_wrapper">

                    {productImages.length > 0 ? (
                      <Swiper
                        modules={[Navigation,Autoplay]}
                        navigation
                        slidesPerView={1}
                        spaceBetween={10}
                        className="product_main_swiper"

                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }}
                        // Store Swiper instance
                        onSwiper={(swiper) => {
                          mainSwiperRef.current = swiper;
                        }}

                        // Update active thumbnail when main slider changes
                        onSlideChange={handleMainSlideChange}
                      >
                        {productImages.map((item, index) => {
                          const imagePath =
                            typeof item === "string"
                              ? item
                              : item?.image || item?.url;

                          return (
                            <SwiperSlide key={item?.id || index}>
                              <div className="main_product_image_holder">
                                <img
                                  src={getImageUrl(imagePath)}
                                  alt={
                                    product?.name
                                      ? `${product.name} ${index + 1}`
                                      : "Product Image"
                                  }
                                  className="product_main_image"
                                />
                              </div>
                            </SwiperSlide>
                          );
                        })}
                      </Swiper>
                    ) : (
                      <div className="no_product_image">
                        <span>No Image Available</span>
                      </div>
                    )}

                    <div className="product_wishlist"></div>
                  </div>

                  {/* =====================================================
                      THUMBNAIL SWIPER
                  ===================================================== */}

                  {productImages.length > 0 && (
                    <div className="product_thumbnail_wrapper">
                      <Swiper
                        modules={[Navigation]}
                        navigation
                        slidesPerView={5}
                        spaceBetween={10}
                        watchOverflow={true}
                        grabCursor={true}
                        className="product_thumbnail_swiper"


                        breakpoints={{
                          0: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                          },

                          576: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                          },

                          768: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                          },

                          992: {
                            slidesPerView: 3,
                            spaceBetween: 10,
                          },
                        }}
                      >
                        {productImages.map((item, index) => {
                          const imagePath =
                            typeof item === "string"
                              ? item
                              : item?.image || item?.url;

                          return (
                            <SwiperSlide
                              key={item?.id || index}
                              onClick={() =>
                                handleThumbnailClick(index)
                              }
                            >
                              <div
                                className={`product_thumbnail ${
                                  activeImage === index
                                    ? "active_thumbnail"
                                    : ""
                                }`}
                              >
                                <img
                                  src={getImageUrl(imagePath)}
                                  alt={`Product Thumbnail ${index + 1}`}
                                  className="product_thumbnail_img"
                                />
                              </div>
                            </SwiperSlide>
                          );
                        })}
                      </Swiper>
                    </div>
                  )}

                  {/* =====================================================
                      IMAGE BOTTOM INFO
                  ===================================================== */}

                  <div className="product_image_bottom">
                    <span>Certified Quality</span>

                    <span>•</span>

                    <span>Farmer Friendly</span>
                  </div>
                </div>
              </div>

              {/* =====================================================
                  PRODUCT CONTENT
              ===================================================== */}

              <div className="col-lg-7 col-md-7 col-12 product_content_col">

                {/* CATEGORY */}

                <span className="product_category">
                  {product?.category_id?.label ||
                    "AGRICULTURE SOLUTION"}
                </span>

                {/* PRODUCT NAME */}

                <h2 className="product_title">
                  {product.name}
                </h2>

                {/* PRICE */}

                {product.price !== null &&
                  product.price !== undefined && (
                    <div className="product_price">
                      <span>₹</span> {product.price}
                    </div>
                  )}

                {/* DESCRIPTION */}

                {product?.description && (
                  <div
                    className="product_description"
                    dangerouslySetInnerHTML={{
                      __html: product.description,
                    }}
                  />
                )}

                {/* DETAIL DESCRIPTION */}

                {product?.detail_description && (
                  <div
                    className="product_description"
                    dangerouslySetInnerHTML={{
                      __html: product.detail_description,
                    }}
                  />
                )}

                {/* =====================================================
                    BENEFITS
                ===================================================== */}

                {product.benefits?.length > 0 && (
                  <div className="product_features">

                    <h4>Key Features</h4>

                    <div className="feature_grid">
                      {product.benefits.map((benefit) => (
                        <div
                          className="feature_item"
                          key={benefit.id}
                        >
                          <span className="feature_icon">
                            <FontAwesomeIcon icon={faCheck} />
                          </span>

                          <div>
                            <strong>
                              {benefit.title}
                            </strong>

                            <p>
                              {benefit.content}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* =====================================================
                    CTA BUTTONS
                ===================================================== */}

                <div className="product_cta">

                  {/* BROCHURE */}

                  {product?.brochure && (
                    <a
                      href={IDS.IMG_URL + product.brochure}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      className="download_btn brochure_btn"
                    >
                      <FontAwesomeIcon
                        icon={faFileArrowDown}
                      />

                      Brochure
                    </a>
                  )}

                  {/* CATALOGUE */}

                  {product?.catalogue && (
                    <a
                      href={IDS.IMG_URL + product.catalogue}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      className="download_btn catlogue_btn"
                    >
                      <FontAwesomeIcon
                        icon={faBookOpen}
                      />

                      Catalogue
                    </a>
                  )}

                  {/* WHATSAPP */}

                  <a
                    href="https://wa.me/919096247296"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp_btn"
                    aria-label="Chat with us on WhatsApp"
                  >
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          ENQUIRE MODAL
      ===================================================== */}

      <Enquire_from_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      {/* =====================================================
          INNER PRODUCTS
      ===================================================== */}

      <Inner_Products
        categoryId={
          product?.category_id?.value ||
          product?.category_id
        }
      />
    </>
  );
};

export default Product_Description;